import { APP_INITIALIZER } from '@angular/core';
import { AppConfigService } from './Services/app-config.service';

import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
//  import { all } from '@awesome.me/kit-0629a5baa2/icons';

import { AppComponent } from './app.component';
import { WeatherComponent } from './Components/weather/weather.component';
import { PortInfoComponent } from './Components/port-info/port-info.component';
import { TopheaderComponent } from './Components/topheader/topheader.component';
import { FancyPageTitleComponent } from './Components/fancy-page-title/fancy-page-title.component';
import { BottommenuComponent } from './Components/bottommenu/bottommenu.component';
import { CurrentDateComponent } from './Components/current-date/current-date.component';
import { MealTimesComponent } from './Components/meal-times/meal-times.component';
import { MyDayComponent } from './Components/my-day/my-day.component';
import { LoginPageComponent } from './Components/login-page/login-page.component';
import { FullLogoComponent } from './Components/full-logo/full-logo.component';
import { LoginPromptComponent } from './Components/login-prompt/login-prompt.component';

import { AppRoutingModule } from './app-routing.module';
import { PortInfopageComponent } from './Components/port-infopage/port-infopage.component';
import { PortDescriptionComponent } from './Components/port-description/port-description.component';
import { DockAddressExpanderComponent } from './Components/dock-address-expander/dock-address-expander.component';
import { ContactPageComponent } from './Components/contact-page/contact-page.component';
import { ContactExpanderComponent } from './Components/contact-expander/contact-expander.component';
import { PortalPageComponent } from './Components/portal-page/portal-page.component';
import { GoldbarComponent } from './Components/goldbar/goldbar.component';

import { ShipinfoPageComponent } from './Components/shipinfo-page/shipinfo-page.component';
import { CurrentItineraryComponent } from './Components/current-itinerary/current-itinerary.component';
import { ShipNameComponent } from './Components/ship-name/ship-name.component';
import { DeckPlansComponent } from './Components/deck-plans/deck-plans.component';
import { FAQPageComponent } from './Components/faq-page/faq-page.component';
import { FaqExpanderComponent } from './Components/faq-expander/faq-expander.component';
import { MealActivityPageComponent } from './Components/meal-activity-page/meal-activity-page.component';
import { DiningTimesComponent } from './Components/dining-times/dining-times.component';
import { LonggoldbarComponent } from './Components/longgoldbar/longgoldbar.component';
import { MydayGlanceComponent } from './Components/myday-glance/myday-glance.component';
import { DailyHighlightsComponent } from './Components/daily-highlights/daily-highlights.component';

import { BookingCredentials } from './booking-credentials';
import { CrewPageComponent } from './Components/crew-page/crew-page.component';
import { BioExpanderComponent } from './Components/bio-expander/bio-expander.component';
import { ShipBannerComponent } from './Components/ship-banner/ship-banner.component';
import { PhoneFormatPipe } from './phone-format.pipe';
import { ReplaceLineBreaksPipe } from './replace-line-breaks.pipe';
import { PortBannerComponent } from './Components/port-banner/port-banner.component';
import { timepipe } from './time.pipe';
import { ShiplocationPageComponent } from './Components/ship-location-page/ship-location-page.component';
import { NavigationService } from './Services/navigation.service';

import { SpinnerInterceptor } from './Services/spinner-interceptor.service';
import { HttpErrorInterceptor } from './Services/http-error-interceptor.service';
import { MealDescriptionPageComponent } from './Components/meal-description-page/meal-description-page.component';
import { TodaysMenuComponent } from './Components/todaysmenu/todaysmenu.component';
import {
  BrowserAnimationsModule,
  NoopAnimationsModule,
} from '@angular/platform-browser/animations';

import { MatStepperModule } from '@angular/material/stepper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OnboardRebookingPageComponent } from './Components/onboard-rebooking-page/onboard-rebooking-page.component';
import { EagleSocietyPromoComponent } from './Components/eagle-society-promo/eagle-society-promo.component';
import { OnboardRebookingComponent } from './Components/onboard-rebooking/onboard-rebooking.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { ReactiveFormsModule } from '@angular/forms';
import { EagleSocietyPageComponent } from './Components/eagle-society-page/eagle-society-page.component';
import { TestComponent } from './Components/test/test.component';
import { ConfirmationDialogComponent } from './Components/confirmation-dialog/confirmation-dialog.component';
import { AlertDialogComponent } from './Components/alert-dialog/alert-dialog.component';
import { MatDialogClose, MatDialogModule, MAT_DIALOG_DEFAULT_OPTIONS, MatDialogConfig } from '@angular/material/dialog';
import { Overlay } from '@angular/cdk/overlay';
import { EntertainmentActivityPageComponent } from './Components/entertainment-activity-page/entertainment-activity-page.component';
import { EntertainmentTimesComponent } from './Components/entertainment-times/entertainment-times.component';
import { EntertainmentDialogComponent } from './Components/entertainment-dialog/entertainment-dialog.component';
import { LonggoldbarDialogComponent } from './Components/longgoldbar-dialog/longgoldbar-dialog.component';
import { ShoreExcursionsPageComponent } from './Components/shore-excursions-page/shore-excursions-page.component';
import { ShoreExcursionsComponent } from './Components/shore-excursions/shore-excursions.component';
import { ShoreExcursionsCruiseComponent } from './Components/shore-excursions-cruise/shore-excursions-cruise.component';
import { ShoreExcursionSignupComponent } from './Components/shore-excursion-signup/shore-excursion-signup.component';
import { PCIComponent } from './Components/pci/pci.component';
import { PCIPageComponent } from './Components/pci-page/pci-page.component';
import { PCIDataComponent } from './Components/pcidata/pcidata.component';
import { WeatherforecastComponent } from './Components/weatherforecast/weatherforecast.component';
import { ItineraryExplorerComponent } from './Components/itinerary-explorer/itinerary-explorer.component';
import { ItineraryExplorerPageComponent } from './Components/itinerary-explorer-page/itinerary-explorer-page.component';
import { ItineraryExplorerIntroComponent } from './Components/itinerary-explorer-intro/itinerary-explorer-intro.component';
import { ExcursionDialogComponent } from './Components/excursion-dialog/excursion-dialog.component';
import { AdminLoginPageComponent } from './Components/admin-login-page/admin-login-page.component';
import { ShipSelectComponent } from './Components/ship-select/ship-select.component';
import { ShipDropdownListComponent } from './Components/ship-dropdown-list/ship-dropdown-list.component';
import { CafeDescriptionPageComponent } from './Components/cafe-description-page/cafe-description-page.component';
import { CafeMenuComponent } from './Components/cafe-menu/cafe-menu.component';
import { MealSelectionPageComponent } from './Components/meal-selection-page/meal-selection-page.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { LocalloopPageComponent } from './Components/localloop-page/localloop-page.component';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { DraggableBoxComponent } from './Components/image-zoom-container/draggable-box/draggable-box.component';
import { ImageZoomContainerComponent } from './Components/image-zoom-container/image-zoom-container.component';
import { LogoutComponent } from './Components/logout/logout.component';
import { EnrichmentGuidePointsofinterestPageComponent } from './Components/enrichment-guide-pointsofinterest-page/enrichment-guide-pointsofinterest-page.component';
import { DirectionArrowComponent } from './Components/direction-arrow/direction-arrow.component';
import { PoiItemComponent } from './Components/poi-item/poi-item.component';
import { AudioPlayerComponent } from './Components/audio-player/audio-player.component';
import { MatSliderModule } from '@angular/material/slider';
import { PageNotFoundComponent } from './Components/page-not-found/page-not-found.component';

@NgModule({
  declarations: [
    AppComponent,
    WeatherComponent,
    PortInfoComponent,
    TopheaderComponent,
    FancyPageTitleComponent,
    BottommenuComponent,
    CurrentDateComponent,
    MealTimesComponent,
    MyDayComponent,
    LoginPageComponent,
    FullLogoComponent,
    LoginPromptComponent,
    PortInfopageComponent,
    PortDescriptionComponent,
    DockAddressExpanderComponent,
    ContactPageComponent,
    ContactExpanderComponent,
    PortalPageComponent,
    GoldbarComponent,
    ShipinfoPageComponent,
    CurrentItineraryComponent,
    ShipNameComponent,
    DeckPlansComponent,
    FAQPageComponent,
    FaqExpanderComponent,
    MealActivityPageComponent,
    DiningTimesComponent,
    LonggoldbarComponent,
    MydayGlanceComponent,
    DailyHighlightsComponent,
    CrewPageComponent,
    BioExpanderComponent,
    ShipBannerComponent,
    PhoneFormatPipe,
    ReplaceLineBreaksPipe,
    PortBannerComponent,
    timepipe,
    ShiplocationPageComponent,
    MealDescriptionPageComponent,
    TodaysMenuComponent,

    OnboardRebookingPageComponent,
    EagleSocietyPromoComponent,
    OnboardRebookingComponent,
    EagleSocietyPageComponent,
    TestComponent,
    ConfirmationDialogComponent,
    AlertDialogComponent,
    EntertainmentActivityPageComponent,
    EntertainmentTimesComponent,
    EntertainmentDialogComponent,
    LonggoldbarDialogComponent,
    ShoreExcursionsPageComponent,
    ShoreExcursionsComponent,
    ShoreExcursionsCruiseComponent,
    ShoreExcursionSignupComponent,
    PCIComponent,
    PCIPageComponent,
    PCIDataComponent,
    WeatherforecastComponent,
    ItineraryExplorerComponent,
    ItineraryExplorerPageComponent,
    ItineraryExplorerIntroComponent,
    ExcursionDialogComponent,
    AdminLoginPageComponent,
    ShipSelectComponent,
    ShipDropdownListComponent,
    CafeDescriptionPageComponent,
    CafeMenuComponent,
    MealSelectionPageComponent,
    LocalloopPageComponent,
    DraggableBoxComponent,
    ImageZoomContainerComponent,
    LogoutComponent,
    EnrichmentGuidePointsofinterestPageComponent,
    DirectionArrowComponent,
    PoiItemComponent,
    AudioPlayerComponent,
    PageNotFoundComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    NoopAnimationsModule,
    MatStepperModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatRadioModule,
    MatCheckboxModule,
    ReactiveFormsModule,
    MatDialogModule,
    BrowserAnimationsModule,
    FontAwesomeModule,
    MatSlideToggleModule,
    MatSliderModule
  ],
  providers: [
    NavigationService,
    BookingCredentials,
    {
      provide: APP_INITIALIZER,
      multi: true,
      deps: [AppConfigService],
      useFactory: (appConfigService: AppConfigService) => {
        return () => {
          return appConfigService.loadAppConfig();
        };
      },
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpErrorInterceptor,
      multi: true,
    },
    {
      provide: MAT_DIALOG_DEFAULT_OPTIONS,
      deps: [Overlay],
      useFactory: (overlay: Overlay): MatDialogConfig => ({
        // Page scroll lives in .scrollingcontainer, not body. BlockScrollStrategy
        // locks body position and often fails to restore cleanly in iOS WebView after close.
        scrollStrategy: overlay.scrollStrategies.noop(),
        restoreFocus: false,
      }),
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
